import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";
import { useEffect } from "react";

import { SiteShell } from "@/components/site/shell";
import { DEFAULT_LANG, LANGS, getDict, isLang, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang")({
  beforeLoad: ({ params }) => {
    if (!isLang(params.lang)) throw notFound();
  },
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ params, match }) => {
    const cleanPath = match.pathname.replace(/^\/(tr|en|fr)(?=\/|$)/, "") || "";
    const siteUrl = "https://insidermark.com";
    const links: { rel: string; hrefLang: string; href: string }[] = LANGS.map((l) => ({
      rel: "alternate",
      hrefLang: l,
      href: `${siteUrl}/${l}${cleanPath}`,
    }));
    links.push({ rel: "alternate", hrefLang: "x-default", href: `${siteUrl}/${DEFAULT_LANG}${cleanPath}` });
    return {
      links,
      meta: [{ name: "content-language", content: params.lang }],
    };
  },
  component: LangLayout,
});

function LangLayout() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.classList.add("im");
  }, [lang]);
  return (
    <SiteShell lang={lang} t={t}>
      <Outlet />
    </SiteShell>
  );
}
